import { get } from 'lodash';

import { Controller } from 'react-hook-form';

import { FormItem, NumberInput } from '@ingrid/luterkort-react';

import { ValidationError } from '~src/components/ValidationError/ValidationError';

import { ValidateSchema } from '../../create/validate';
import { DynamicPath, useCarrierContractFormContext } from '../../types';
import { Schema } from '../queries';
import { SchemaFormLabel } from './schema-form-label';

interface Props {
  schemaId: string;
  schema: Schema;
  path?: string;
}

export function SchemaFormNumber({ schema, schemaId, path = '' }: Props) {
  const { formState, control } = useCarrierContractFormContext();

  return (
    <FormItem.Root>
      <SchemaFormLabel schema={schema} path={path} schemaId={schemaId} />

      <Controller
        control={control}
        rules={ValidateSchema(path, schemaId)}
        name={path as DynamicPath}
        render={({ field }) => (
          <FormItem.Control invalid={!!get(formState.errors, path)?.message}>
            <NumberInput
              {...field}
              onChange={event => field.onChange(event)}
              formatOptions={{ maximumFractionDigits: 8 }}
              value={field.value as number | undefined}
            />
          </FormItem.Control>
        )}
      />

      <ValidationError errors={formState.errors} name={path} />
    </FormItem.Root>
  );
}
